module.exports = __webpack_public_path__ + "static/media/MESSAGE FROM THE 2015 EXECUTIVE COMMITTEE_final_RM_LB_030816.14c65b2f.pdf";